"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../../../utils/theme");
var iconColorsMap = {
    chc: theme_1.colors.orange,
    oxr: theme_1.colors.blue1,
    sxr: theme_1.colors.green4,
    txr: theme_1.colors.red4,
    tsxr: theme_1.colors.red4,
    tr: theme_1.colors.purple0,
};
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 3em;\n  width: 3em;\n  min-height: 3em;\n  min-width: 3em;\n  border-radius: 4px;\n  background-color: ", ";\n  font-size: ", ";\n  font-weight: bold;\n  line-height: initial;\n  color: ", ";\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  height: 3em;\n  width: 3em;\n  min-height: 3em;\n  min-width: 3em;\n  border-radius: 4px;\n  background-color: ",
    ";\n  font-size: ", ";\n  font-weight: bold;\n  line-height: initial;\n  color: ", ";\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (_a) {
    var type = _a.type, color = _a.color;
    return color ? color : iconColorsMap[type] || theme_1.colors.grey9;
}, function (_a) {
    var fontSize = _a.fontSize;
    return fontSize || '8px';
}, theme_1.colors.white);
var templateObject_1;
//# sourceMappingURL=styles.js.map